<template>
  <div class="col-label">
    <el-popover
      width="200"
      placement="top"
      trigger="hover"
      v-if="showPopover"
    >
      <div class="col-label">
        <el-tag
          v-for="(tag, index) in tags.slice(2)"
          size="medium"
          :key="index"
          type="info"
        >
          {{ tag }}
        </el-tag>
      </div>
      <div slot="reference">
        <el-tag
          v-for="(tag, index) in tags.slice(0, 2)"
          size="medium"
          :key="index"
          type="info"
        >
          {{ tag }}
        </el-tag>
      </div>
    </el-popover>
    <!-- 不要fragment  上使用 v-if -->
    <!-- vue patch node 的时候回找不到元素，到纸页面报错 -->
    <div v-if="!showPopover">
      <el-tag
        v-for="(tag, index) in tags"
        size="medium"
        :key="index"
        type="info"
      >
        {{ tag }}
      </el-tag>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    showPopover: {
      type: Boolean,
      default: () => false,
    },
  },
}
</script>

<style lang="scss" scoped>
.col-label {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: -10px 0px 0px -10px;
  .el-tag {
    margin: 10px 0px 0px 10px;
  }
}
</style>
